module.exports = __webpack_public_path__ + "img/a4.6921d1ed.png";